export const kitSKUColumns = [
  {
    field: "lineNo",
    headerName: "Line",
    sortable: false,
    align: "center",
    headerAlign: "center",
    width: 80,
  },
  {
    field: "skuCode",
    headerName: "SKU Code",
    sortable: false,
    align: "left",
    flex: 2,
    minWidth: 200,
  },
  {
    field: "skuDescription",
    headerName: "Description",
    sortable: false,
    align: "left",
    flex: 1.5,
    minWidth: 150,
  },
  {
    field: "quantity",
    headerName: "Quantity",
    sortable: false,
    align: "right",
    flex: 1,
    minWidth: 100,
    headerAlign: "right",
    headerClassName: 'right-align-header',
  },
];